import { BsXLg } from "react-icons/bs";
import css from "./FullSizeImgModal.module.css";
import ReactDOM from "react-dom";
import { useRef, useState } from "react";

function FullSizeImgModal({
  isOpen,
  imgUrl,
  onClose,
  diag,
  isScheme = false,
  item,
}) {
  const [isZoomed, setIsZoomed] = useState(false);
  const [naturalSize, setNaturalSize] = useState({ w: 0, h: 0 });
  const modalContentRef = useRef(null);
  const imgRef = useRef(null);

  const isDragging = useRef(false);
  const startPos = useRef({ x: 0, y: 0 });
  const scrollStart = useRef({ left: 0, top: 0 });

  if (!isOpen) {
    return null;
  }

  const handleImageLoad = e => {
    const img = e.target;
    setNaturalSize({ w: img.naturalWidth, h: img.naturalHeight });
  };

  const handleDragStart = e => {
    if (!isZoomed) return;
    isDragging.current = true;

    modalContentRef.current.classList.add(css.dragging);

    const pageX = e.touches ? e.touches[0].pageX : e.pageX;
    const pageY = e.touches ? e.touches[0].pageY : e.pageY;

    startPos.current = { x: pageX, y: pageY };

    const cont = modalContentRef.current;
    scrollStart.current = {
      left: cont.scrollLeft,
      top: cont.scrollTop,
    };
  };

  const handleDragMove = e => {
    if (!isZoomed || !isDragging.current) return;
    e.preventDefault();

    const pageX = e.touches ? e.touches[0].pageX : e.pageX;
    const pageY = e.touches ? e.touches[0].pageY : e.pageY;

    const dx = pageX - startPos.current.x;
    const dy = pageY - startPos.current.y;

    const cont = modalContentRef.current;

    cont.scrollLeft = scrollStart.current.left - dx;
    cont.scrollTop = scrollStart.current.top - dy;
  };

  const handleDragEnd = () => {
    isDragging.current = false;
    modalContentRef.current.classList.remove(css.dragging);
  };

  const handleImageClick = e => {
    e.stopPropagation();

    setIsZoomed(!isZoomed);

    // коли увімкнули зум — центрируємо скрол контейнера на центр зображення
    if (!isZoomed) {
      requestAnimationFrame(() => {
        const cont = modalContentRef.current;
        const imgEl = imgRef.current;
        if (cont && imgEl) {
          const scrollLeft = (imgEl.offsetWidth - cont.clientWidth) / 2;
          const scrollTop = (imgEl.offsetHeight - cont.clientHeight) / 2;

          cont.scrollLeft = Math.max(0, Math.round(scrollLeft));
          cont.scrollTop = Math.max(0, Math.round(scrollTop));
        }
      });
    }
  };

  return ReactDOM.createPortal(
    <div
      className={css.modal}
      onClick={() => {
        setIsZoomed(false);
        onClose();
      }}
    >
      <div
        ref={modalContentRef}
        className={`${css.modalContent} ${isZoomed ? css.zoomedContainer : ""}`}
        onMouseDown={handleDragStart}
        onMouseMove={handleDragMove}
        onMouseUp={handleDragEnd}
        onMouseLeave={handleDragEnd}
        onTouchStart={handleDragStart}
        onTouchMove={handleDragMove}
        onTouchEnd={handleDragEnd}
        onClick={e => e.stopPropagation()}
      >
        <BsXLg
          className={css.closeIcon}
          onClick={() => {
            setIsZoomed(false);
            onClose();
          }}
        />
        <img
          ref={imgRef}
          draggable="false"
          src={imgUrl}
          alt="Повне зображення"
          onClick={handleImageClick}
          onLoad={handleImageLoad}
          className={`${css.modalImage} ${diag ? css.modalImageDiag : ""}`}
          // inline style: коли zoom, робимо реальні розміри картинки (2x)
          style={
            isZoomed
              ? {
                  width: naturalSize.w
                    ? Math.min(naturalSize.w * 2, naturalSize.w * 4)
                    : "200%",
                  height: "auto",
                  maxWidth: isScheme ? "none" : "100vw",
                  maxHeight: isScheme ? "none" : "100vh",
                  objectFit: "contain",
                }
              : {}
          }
        />
        {isScheme && item && (
          <div
            className={`${css.itemDetails} ${
              isZoomed ? css.itemDetailsZoomed : ""
            }`}
          >
            <p>Назва: {item.name.toLowerCase()}</p>
            <p>OEM: {item.oem}</p>
            <p>Код на зображенні: {item.codeonimage || item.code_im}</p>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}

export default FullSizeImgModal;
